import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useScModel } from "../scModel";

export function PageHeader() {
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useScModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "贸易国别",
            fieldName: "countryCode",
            options: getSelectedDictOne(DictCodeEnmu.COUNTRY)
        },
        {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "商品类型",
            fieldName: "typeCode",
            treeData: getTreeSelectOne(DictCodeEnmu.MATERIAL_TYPE),
        },
    ]

    return (
        <YhPageHeader
            title="客户分析列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}